import environment from "../env";
import { completePaymentSchema } from "../graphql/mutations/initiatePayment";
import { MutationResult, useMutation } from "@apollo/client";

interface PaymentPayload {
  idempotencyKey: string;
  oneTimePin: string;
  emailOrPhone: UserIdentify;
  requestId: string;
  tokenId: string;
}

interface UserIdentify {
  email: string;
  phoneNumber: string;
}

export const useCompletePayment = () => {
  const variables = {
    variables: { ...environment.paymentService },
    onError() {},
  };
  const [initiate, request] = useMutation(completePaymentSchema, variables);

  const completePayment = (input: PaymentPayload) => {
    initiate({ variables: { input }, onError() {} });
  };

  return [request, completePayment] as [MutationResult<any>, Function];
};
